import { createSelector } from '@ngrx/store';
import { getHistoryOrderByOrderGUID } from '../getHistoryOrderByOrderGUID';

export const getHistoryOrderStatus = (orderGUID: string) => createSelector(getHistoryOrderByOrderGUID(orderGUID), (order) => order?.data?.Status || null);
